<template>
	<div>
		<!-- 新增、编辑业主信息 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false"
			 :modal-append-to-body="false" :before-close="handleClose">
			<el-form :model="formData" :rules="rules" ref="formData" label-width="120px">
				<el-form-item prop="label" label="类型">
					<el-select v-model="formData.label" placeholder="请输入类型">
						<el-option v-for="(item, index) in checkStatus" :label="item.label" :value="item.label"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="unitName" label="单位名称">
					<el-input v-model="formData.unitName" placeholder="请输入单位名称"></el-input>
				</el-form-item>
				<el-form-item prop="organizationCode" label="组织代码">
					<el-input v-model="formData.organizationCode" placeholder="请输入组织代码"></el-input>
				</el-form-item>
				<el-form-item prop="industry" label="行业类型">
					<el-input v-model="formData.industry" placeholder="请输入行业类型"></el-input>
				</el-form-item>
				<el-form-item prop="chargePersonName" label="负责人">
					<el-input v-model="formData.chargePersonName" placeholder="请输入负责人"></el-input>
				</el-form-item>
				<el-form-item prop="chargePersonPhone" label="负责人电话">
					<el-input v-model="formData.chargePersonPhone" placeholder="请输入负责人电话" maxlength="11"></el-input>
				</el-form-item>
				<el-form-item prop="roomNum" label="名下客房数">
					<el-input v-model.number="formData.roomNum" type="number" placeholder="请输入客房数" min="0"></el-input>
				</el-form-item>
				<el-form-item label="LOGO上传">
					<el-upload class="avatar-uploader" action="/api/admin/ownerManage/uploadOwnerManageFile"
						:show-file-list="false" :on-success="handleAvatarSuccess" :headers="headerData" name="file"
						:before-upload="beforeAvatarUpload">
						<img v-if="formData.showPath" :src="formData.showPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过1MB</div>
					</el-upload>
					</el-upload>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
	props: ["title", "dialogVisible", "formDataDetail"],
	data() {
		return {
			disabled: false,
			formData: {
				label: null, //标签
				unitName: null, //单位名称
				organizationCode: null, //组织代码
				chargePersonName: null, //负责人
				chargePersonPhone: null, //负责人号码
				roomNum: null, //名下客房数
				contractFilePathList: [], //合同附件
				logoFilePathList: [], //logo文件路径
				certificateFilePathList: [], //事业单位法人证书
				showPath: null,
				filePath: null,
				industry: null
			},
			formData2: {
				label: null, //标签
				unitName: null, //单位名称
				organizationCode: null, //组织代码
				chargePersonName: null, //负责人
				chargePersonPhone: null, //负责人号码
				roomNum: null, //名下客房数
				contractFilePathList: [], //合同附件
				logoFilePathList: [], //logo文件路径
				certificateFilePathList: [], //事业单位法人证书
				showPath: null,
				filePath: null,
				industry: null
			},
			// 所有标签
			checkStatus: [{
				label: "高校",
				value: 2,
			},
			{
				label: "省属企业",
				value: 3,
			},
			{
				label: "科研院",
				value: 4,
			},
			{
				label: "其他",
				value: 5,
			},
			],
			// 请求头携带token
			headerData: {
				Authorization: localStorage.access_token
			},
			rules: {
				label: [{
					required: true,
					message: "类型不能为空",
					trigger: ["blur", "change"]
				}],
				unitName: [{
					required: true,
					message: "单位名称不能为空",
					trigger: ["blur", "change"]
				}],
				organizationCode: [{
					required: true,
					message: "组织代码不能为空",
					trigger: ["blur", "change"]
				}],
				industry: [{
					required: true,
					message: "行业类型不能为空",
					trigger: ["blur", "change"]
				}],
			}
		}
	},
	watch: {
		dialogVisible() {
			if (this.title.indexOf("新增") > -1) {
				// this.$nextTick(() => {
				// 	console.log("---------");
				// 	console.log(this.formData)
				// 	console.log(this.$refs.formData.resetFields());
				// 	console.log(this.$refs.formData);

				// 	 this.$refs.formData.resetFields();
				// 	console.log(this.formData);
				// })
				this.formData = {
					...this.formData2
				};
			} else {
				console.log("999999999999", this.formDataDetail);
				this.formData = {
					...this.formDataDetail
				};
			}

		}
	},
	methods: {
		// 取消
		cancelClick() {
			this.close();
		},
		confirmClick() {
			this.$refs.formData.validate((valid) => {
				if (valid) {
					let loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});

					if (this.title.indexOf("新增") > -1) {
						this.$http.post("/api/ownerManage/addOwnerManage", {
							...this.formData,
							createId: 1,
						}).then(res => {
							loading.close();
							console.log("增加", res);
							this.$message.success(res.data.message);
							this.close();
						})
					} else {
						this.$http.post("/api/ownerManage/modifyOwnerManage", {
							...this.formData
						}).then(res => {
							loading.close();
							if (res.data.code != -1) {
								this.$message.success(res.data.message);
								this.close();
							} else {
								this.$message.error(res.data.message);
							}
						})
					}
				} else {
					return;
				}

			})

		},
		// 确定
		// confirmClick() {
		// 	if (this.title.indexOf("新增") > -1) {
		// 		this.$http.post("/api/ownerManage/addOwnerManage", {
		// 			...this.formData,
		// 			createId: 1,
		// 		}).then(res => {
		// 			console.log("增加", res);
		// 			this.$message.success(res.data.message);
		// 			this.close();
		// 		})
		// 	} else {
		// 		this.$http.post("/api/ownerManage/modifyOwnerManage", {
		// 			...this.formData
		// 		}).then(res => {
		// 			console.log("修改", res);
		// 			this.$message.success(res.data.message);
		// 			this.close();
		// 		})
		// 	}
		// },
		// 关闭之前的回调
		handleClose(done) {
			this.close();
		},
		// 关闭模态框向父组件传dialogVisible
		close() {
			this.$emit("changeVisible", {
				dialogVisible: false,
			})
		},

		// 上传之前
		beforeAvatarUpload(file) {
			console.log(file);
			var isJPG = null;
			if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
				isJPG = true;
			} else {
				isJPG = false;
			}
			const isLt2M = file.size / 1024 / 1024 < 1;
			if (!isJPG) {
				this.$message.error('上传Logo只能是 JPG/JPEG/PNG 格式!');
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 1MB!');
			}
			return isLt2M && isJPG;
		},

		// 上传成功
		handleAvatarSuccess(file) {
			console.log(file);
			this.formData.filePath = file.data.filePath;
			this.formData.showPath = file.data.showPath;
			console.log(this.formData);
		},

	}
}
</script>

<style scoped="scoped">
>>>.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

>>>.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 148px;
	height: 148px;
	line-height: 148px;
	text-align: center;
}

.avatar {
	width: 148px;
	height: 148px;
	display: block;
}
</style>
